export enum MediaPlatform {
  mobile = 'mobile',
  tablet = 'tablet',
  desktop = 'desktop',
  largeDesktop = 'largeDesktop',
  extraLargeDesktop = 'extraLargeDesktop',
}
